var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"team-page",attrs:{"id":"team-container"}},[_c('c-banner-team'),_c('c-team-page-team')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }